var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendaPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.410156,
    y: 0.806641,
    width: 96,
    height: 96,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_226_3858",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_226_3858",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACYklEQVR4nO2dPW4VMRSFp4HFBAQ+YoG+oobwCKJgC7TIpiDsgC6wECAdPw9NRIGESAo0893Y55NuG59zj3/mKZK9LMYYY8xGqMfxulpgsusb3qCS6xveoJLrG96gkusb3qCS6xveoJLrG96gkusb3qCS67uRB2/qffV6UKsf1erlTYZufbV6eeW118PqHWv8yet6Vy1eqscPvCmdqdLr99LjxdqL3ZtferynG6AkVVo93zWE3zMfN65EVVo926X56763Lj3asJLV2pOHbx/f2zwAtXhOm1XSKq2e7hHAJ9qo8tbFHgF8TWD0mLFKr1+2DyCBUSUuB9AdAD4L5RXAN0LegvhmCCifAd0B4LNQXgF8I+QtiG+GgPIZ0B0APgvlFcA3QrNuQcvgiPaPC4DB/eMCYHD/uAAY3D8uAAb3jwuAwf3jAmBw/7gAGNw/LgAG948LgMH94wJgcP+4ABjcPy1Ak4+PC9Dk4+MCNPn4uABNPj4uQJOPjwvQ5OPjAjT5+LgATT7+5gJ0w9//38ruHxcgB+AArkOt/vQK6OAW5ACCPQMcQDiAqQ/h5jPg6AAm/iGk0VdA+vEdQDgAr4DwFiRvQT4D5EM4fAj7Kyjm+gylmf4zlMYBwDgAGAcA4wBgHACMA5g9gPVy0q3/a6VbWqXF580D8NXFwV5dXFo8o2ea0lZ9snkA6xXtvr4+/vGaRj1Z9mB9toOfbZGs6mHZ9QmTVs9505GjWrx79OHVnd0C+COEs5m3o9Li2zrzd2/+X2dCq6frF8AUbwu0K48XpcfT3fZ8Y4wxxhhjjDHGGLOMwC8+Z0pUYDEMIgAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendaPlus);
export default __webpack_public_path__ + "static/media/calenda-plus.b92f7480b6c9008d7f2ed73412eee21b.svg";
export { ForwardRef as ReactComponent };